import List from '@pelckmans/elementis/components/list';

type WithId = { id: string | number };

type MaterialListHeaderProps<T extends WithId> = {
  title: string;
  showSelection: boolean;
  selectedMaterial: T[];
  material: T[];
  addMaterial: (material: T[]) => void;
  removeMaterial: (material: T[]) => void;
};

export default function MaterialListHeader<T extends WithId>({
  showSelection,
  title,
  selectedMaterial,
  material,
  addMaterial,
  removeMaterial,
}: MaterialListHeaderProps<T>) {
  if (showSelection) {
    const materialIds = material.map(m => m.id.toString());
    const selectedMaterialIds = selectedMaterial.map(m => m.id.toString());

    const someSelected = materialIds.some(id => selectedMaterialIds.includes(id));
    const allSelected = materialIds.every(id => selectedMaterialIds.includes(id));

    const onClick = () => {
      if (allSelected) {
        removeMaterial(material);
      } else {
        addMaterial(material);
      }
    };

    return (
      <List.Header
        as="checkbox"
        title={title}
        titleTag="h3"
        prominent
        checked={someSelected}
        indeterminate={someSelected && !allSelected}
        onClick={onClick}
      />
    );
  }
  return <List.Header title={title} titleTag="h3" prominent />;
}
